<template>
  <div class="hello">
    <div style="height: 100%">
      <el-header>
        <v-header/>
      </el-header>
      <el-container style="height: calc(100% - 65px)">
        <router-view ></router-view>
      </el-container>
    </div>
  </div>
</template>

<script>
import Header from "./header/header"

export default {
  name: 'HelloWorld',
  components: {
    "v-header": Header,
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped type="text/css" lang="scss">
.hello {
  height: 100%;
  position: fixed;
  width: 100%;
  min-width: 1280px;
  .el-header {
    height: 65px !important;
    //background: #009eff;
    background: url("/web/static/images/header.jpg");
    background-size: 100% 100%;
  }
  header {
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue